import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, Divider, Box, Button } from '@material-ui/core';
import { inject, observer } from 'mobx-react';

import IconDelivery from '../../assets/icons/icon_delivery.png';

import ProductCard from '../../components/ProductCard';
import ScheduleModal from '../../components/ScheduleModal';
import ScheduleButton from '../../components/ScheduleButton';
import ScheduleLink from '../../components/ScheduleLink';

import ModalStore from '../../stores/ModalStore';
import RouterStore from '../../stores/RouterStore';

import { productsAvailableToSchedulingStyles } from './styles';

const ProductsAvailableToScheduling = props => {
  const { productsAvailableToScheduling } = props;

  const classes = productsAvailableToSchedulingStyles(props);

  const handleSchedulingAssemblyButtonClick = () => {
    const { modalStore } = props;
    const { openModal } = modalStore;

    openModal(productsAvailableToScheduling);
  };

  const handleContinueSchedulingAssemblyButtonClick = () => {
    const { routerStore, modalStore } = props;
    const { history } = routerStore;
    const { closeModal } = modalStore;

    closeModal();

    const uuids = productsAvailableToScheduling.map(item => item.uuid);

    history.push('/agendar', { uuids });
  };

  const handleCloseModal = event => {
    event.preventDefault();

    const { modalStore } = props;
    const { closeModal } = modalStore;

    closeModal();
  };

  return (
    <>
      <Grid item md={12}>
        <Typography variant="h4" gutterBottom>
          Produtos disponíveis para agendamento
        </Typography>
        <Divider />
        <Box className={classes.wrapper}>
          <Grid container className={classes.root}>
            {productsAvailableToScheduling.map(item => (
              <ProductCard key={item.id} product={item.product} />
            ))}
          </Grid>
          <Box className={classes.footer}>
            <Button
              onClick={handleSchedulingAssemblyButtonClick}
              variant="contained"
              size="large"
              fullWidth
              disableElevation
            >
              <Typography>Agendar montagem</Typography>
            </Button>
          </Box>
        </Box>
      </Grid>

      <ScheduleModal title="Confirmação">
        <Box className={classes.modal}>
          <Box mb={1}>
            <img
              src={IconDelivery}
              alt="Caminhão de entrega"
              width="92"
              height="92"
            />
          </Box>
          <Box mb={3} color="#0086ff">
            <Typography className="featured">
              Você já recebeu seu(s) produto(s)?
            </Typography>
          </Box>
          <Box mb={5}>
            <Typography>
              Agende a montagem após a entrega do(s) produto(s).
            </Typography>
          </Box>
          <Box mb={3}>
            <ScheduleButton
              onClick={handleContinueSchedulingAssemblyButtonClick}
              size="large"
            >
              Continuar agendamento
            </ScheduleButton>
          </Box>
          <ScheduleLink onClick={handleCloseModal}>Agendar depois</ScheduleLink>
        </Box>
      </ScheduleModal>
    </>
  );
};

ProductsAvailableToScheduling.propTypes = {
  productsAvailableToScheduling: PropTypes.array.isRequired,
  modalStore: PropTypes.instanceOf(ModalStore).isRequired,
  routerStore: PropTypes.instanceOf(RouterStore).isRequired,
};

export default inject(
  'modalStore',
  'routerStore'
)(observer(ProductsAvailableToScheduling));
